import React, { Component } from 'react';

class Tabs extends Component {
    state = {
      activeTab: this.props.activeTab,
    };

  onTabClick = (tab) => this.setState({ activeTab: tab });

  render() {
    const { props: { children }, state: { activeTab } } = this;
    let tabContent;

    const childMap = Array.isArray(children) ? children : [children];
    const tabs = childMap.map(({ props: { label, children, id } }) => {
      if (label === activeTab) tabContent = children;

      let className = 'tab-list-item';
      if (activeTab === label) className += ' tab-list-active';
      
      return (
        <div
          className={className}
          onClick={ () => this.onTabClick(label, children)}
          key={label}
        >
          { label }
        </div>
      );
    })


    return (
      <div className="tabs">
        <div className="tab-list">
          {tabs}
        </div>
        <div className="ContestLeaderboard__wrap">
        { tabContent }
        </div>
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/features/common/Tabs.js